module.exports = __webpack_public_path__ + "46e48ce0628835f68a7369d0254e4283.ttf";